import {Snackbar, Dialog, ImagePreview} from '@varlet/ui'
window.$Toast = (content) => {
    Snackbar.clear()
    if(typeof content=="string") {
        Snackbar({
            content,
            position: "center",
            duration:1000
        })
    }else{
        Snackbar({
            ...content
        })
    }
}
window.$Dialog = Dialog
window.$previewImg = ImagePreview




